import React from "react"
import { withPrefix } from "gatsby"
import HomepageLogoLink from "../components/homepage-logo-link"
import Cta from "../components/cta"
import DownloadFullReport from "../components/download-full-report"
import Safe from "react-safe"
import socialLinks from "../data/social-links.json"
import Facebook from "../images/footer/icon-facebook.inline.svg"
import Twitter from "../images/footer/icon-twitter.inline.svg"
import Instagram from "../images/footer/icon-instagram.inline.svg"
import LinkedIn from "../images/footer/icon-linkedin.inline.svg"
import YouTube from "../images/footer/icon-youtube.inline.svg"

export default function SiteFooter({ path }) {
  const description =
    "The International Monetary Fund (IMF) is a global organization of 190 member countries set up to promote the health of the world economy."

  const socialLinksTypes = {
    facebook: Facebook,
    twitter: Twitter,
    instagram: Instagram,
    linkedin: LinkedIn,
    youtube: YouTube,
  }

  return (
    <footer className="site-footer">
      <section className="site-footer__main">
        <header>
          <HomepageLogoLink classes="site-footer__about__logo" path={path} />
        </header>

        <div className="site-footer__about">
          <h3 className="title title--r title--uppercase">About the IMF</h3>
          <p className="title--s">{description}</p>
          <Cta type="secondary" href="https://www.imf.org/" text="Learn More" />
        </div>

        <DownloadFullReport />
      </section>

      <div className="site-footer__bottom">
        <div className="site-footer__bottom__inner">
          <div className="site-footer__bottom__social">
            <h4 className="title title--s title--uppercase">Follow Us</h4>
            <ul>
              {socialLinks.map((item, index) => {
                const SvgIcon = socialLinksTypes[item.id]

                return (
                  <li key={index}>
                    <a href={item.href} aria-label={item.name}>
                      <SvgIcon />
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>

          <p className="title--xs">
            Credits for images found in this website can be found{" "}
            <u>
              <a href={withPrefix("/") + "downloads/photo-credits.pdf"}>here</a>
            </u>
            .
          </p>
        </div>
      </div>

      {typeof _satellite !== "undefined" ? (
        <Safe.script type="text/javascript">
          _satellite.pageBottom();
        </Safe.script>
      ) : null}
    </footer>
  )
}
